import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import FooterColores from './FooterColores';
import '../../styles/site.css';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

// Parametros props
// show: si se muestra o no el modal
// title: título del modal
// body: cuerpo del modal
// children: contenido adicional dentro del body

ModalCS.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  size: PropTypes.string,
  body: PropTypes.node,  // Cambiado de object a node para aceptar más tipos de contenido
  className: PropTypes.string, // Cambiado de "class" a "className" para evitar conflictos con palabras reservadas
  handleClose: PropTypes.func,
  children: PropTypes.node,  // Se agregó para aceptar contenido anidado
};

ModalCS.defaultProps = {
  show: false,
  title: 'Default',
  body: <>Body</>,
  size: "md",
  handleClose: () => { },
  className: 'tituloSeccion tituloModal',
};

function ModalCS(props) {
  return (
    <Modal show={props.show} size={props.size} onHide={props.handleClose}>
      <Modal.Header className={props.className}>
        {props.title}
        <IconButton aria-label="close" style={{ position: 'absolute', right: '8px', top: '8px' }} onClick={props.handleClose}
          sx={{
            fontSize: '2rem', '&:focus': { outline: 'none' },
          }}>
          <CloseIcon fontSize="inherit" />
        </IconButton>
      </Modal.Header>
      <Modal.Body>
        {props.children || props.body}
      </Modal.Body>
      <Modal.Footer>
        <FooterColores />
      </Modal.Footer>
    </Modal>
  );
}

export default React.memo(ModalCS);
